export default __webpack_public_path__ + "static/media/admin2steps01.bc896717.svg";